import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ComingSoonCatalogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ComingSoonCatalogQuery = { __typename?: 'query_root', comingSoonCatalog?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', id: string, entryName: string, releaseDate?: Types.Maybe<string>, flagship?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string, brand?: Types.Maybe<string> }> }> }>, combinedPicture?: Types.Maybe<{ __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', alternativeText?: Types.Maybe<string>, formats?: Types.Maybe<any> }> }> }> }> }> }> }> }> }>, tags?: Types.Maybe<{ __typename?: 'TagRelationResponseCollection', data: Array<{ __typename?: 'TagEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'Tag', name: string, slug: string }> }> }> }>>> }> }> }> };


export const ComingSoonCatalogDocument = gql`
    query comingSoonCatalog {
  comingSoonCatalog: b2CSmartphoneCatalog {
    data {
      attributes {
        catalogId
        entries(filters: {category: {eq: "comingSoon"}}) {
          id
          entryName
          releaseDate
          flagship {
            data {
              id
              attributes {
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      smartphoneFamily {
                        data {
                          id
                          attributes {
                            slug
                            brand
                          }
                        }
                      }
                      combinedPicture {
                        data {
                          id
                          attributes {
                            alternativeText
                            formats
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          tags {
            data {
              id
              attributes {
                name
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useComingSoonCatalogQuery(baseOptions?: Apollo.QueryHookOptions<ComingSoonCatalogQuery, ComingSoonCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComingSoonCatalogQuery, ComingSoonCatalogQueryVariables>(ComingSoonCatalogDocument, options);
      }
export function useComingSoonCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComingSoonCatalogQuery, ComingSoonCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComingSoonCatalogQuery, ComingSoonCatalogQueryVariables>(ComingSoonCatalogDocument, options);
        }
export type ComingSoonCatalogQueryHookResult = ReturnType<typeof useComingSoonCatalogQuery>;
export type ComingSoonCatalogLazyQueryHookResult = ReturnType<typeof useComingSoonCatalogLazyQuery>;
export type ComingSoonCatalogQueryResult = Apollo.QueryResult<ComingSoonCatalogQuery, ComingSoonCatalogQueryVariables>;